<template>
	<div>
		<el-dialog title="报修详情" :visible.sync="show" width="30%">
			<xiyiDet :row="row"></xiyiDet>
			<el-divider></el-divider>
			<div v-if="row.status">
				<h3 style="margin-bottom: 10px;">客服处理</h3>
				<div>处理人 ：{{row.approvalName}}</div>
				<div style="margin:  10px 0;">处理时间 ：{{setTime(row.approvalTime)}}</div>
				<div>处理状态 ：{{row.status}}</div>
			</div>
			<div v-if="row.result=='已完成'">
				<h3 style="margin-bottom: 10px;">工人服务</h3>
				<div>上门服务时间 ：{{setTime(row.bdRepairHandle.visitTime)}}</div>
				<div style="margin:  10px 0;">维修结果 ：{{row.bdRepairHandle.result}}</div>
				<div>备注 ：{{row.bdRepairHandle.remark}}</div>
				<div style="margin:  10px 0;">
					<span style="display: flex;align-items: center;">图片 ：</span>
					<div v-for="s in row.bdRepairHandle.showPathList">
						<img :src="s" alt="" width="20%">
					</div>
				</div>

			</div>
			<div v-else>处理中</div>
			<div v-if="row.eflag">
				<h3 style="margin-bottom: 10px;">评价详情</h3>
				<div>评价时间 ：{{setTime(row.bdEvaluate.createTime)}}</div>
				<div style="margin:  10px 0;">评价星级 ：{{row.bdEvaluate.stars}}级</div>
				<div>评价内容 ：{{row.bdEvaluate.content}}</div>
			</div>
			<div v-else>评价中</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
			</span>
		</el-dialog>
		<el-form :inline="true" :model="form" class="demo-form-inline">
			<el-form-item label="报修人">
				<el-input v-model="form.username" placeholder="报修人" clearable=""></el-input>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="getAll()">查询</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="username" label="申请人"></el-table-column>
			<el-table-column prop="phone" label="联系电话"></el-table-column>

		<!-- 	<el-table-column prop="projectName" label="服务项目"></el-table-column> -->
			<el-table-column prop="createTime" label="申请时间">
				<template slot-scope="{row}">{{setTime(row.createTime)}}</template>
			</el-table-column>
			<el-table-column prop="approvalName" label="处理人"></el-table-column>
			<el-table-column prop="approvalTime" label="处理时间">
				<template slot-scope="{row}">{{setTime(row.approvalTime)}}</template>
			</el-table-column>
			<el-table-column prop="status" label="处理状态"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="getRow(row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum">
		</el-pagination>
	</div>
</template>

<script>
	import xiyiDet from "./xiyiDet.vue"
	export default {
		components: {
			xiyiDet
		},
		data() {
			return {
				show: false,
				data: [],
				form: {
					result: "已完成",
					status: "", //
					username: "",
					currentPage: 1,
					pageSize: 10,
					type: '洗衣'
				},
				row: {},
				totalNum: 0
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.form.currentPage = val
				this.getAll()
			},
			handleSizeChange(val) {
				this.form.pageSize = val
				this.getAll()
			},
			getRow(row) {
				this.row = row
				this.show = true
			},
			getAll() {
				this.$http.post(`/api/bdServiceApply/queryServiceApply`, this.form).then(r => {
					if (r.data.data != null) {
						this.data = r.data.data.items
						this.totalNum = r.data.data.totalNum
					} else {
						this.data = null
						this.totalNum = 0
					}

				})
			}
		},
		mounted() {
			this.getAll()
		}
	}
</script>

<style>
</style>
